module.exports = __webpack_public_path__ + "static/media/Invoices.bbd27d4c.svg";